import { gql } from "@apollo/client";

export default gql`
  mutation removePersonalTranscriptSyncCredentialMutation(
    $provider: PersonalTranscriptSyncCredentialProviderEnum!
  ) {
    removePersonalTranscriptSyncCredential(provider: $provider) {
      user {
        id
        hasGranolaPersonalApiToken
        hasFirefliesPersonalApiToken
      }
    }
  }
`;
